$(document).ready(function(){
    var faqTabArr = $('.faq_tabs').find('li');
    var accordionArr = $('.accordion');
    
    faqTabArr.each(function(){
        var THIS = $(this);
        THIS.on('click', function(){
            var currTab = THIS.attr('id');
            var sortedFaqList = $('.faq_' + currTab);
            if(currTab == 'all'){
                $('.accordion').fadeIn(100);
                console.log(accordionArr[0]);
                $('.accordion').removeClass('is-open');
                $(accordionArr[0]).addClass('is-open');
                $('.accordion').find('.accordion_body').css({display:'none'});
                $(accordionArr[0]).find('.accordion_body').css({display:'block'});
            }else{
                $('.accordion').css({display:'none'});
                $(sortedFaqList).fadeIn(200);
            }
            $('.accordion').removeClass('is-open');
            $($(sortedFaqList[0])).addClass('is-open');
            $('.accordion').find('.accordion_body').css({display:'none'});
            $($(sortedFaqList[0])).find('.accordion_body').css({display:'block'});
            faqTabArr.removeClass('active_faq');
            THIS.addClass('active_faq');
        });
    });
});